import { FC } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

/**
 * Represents the action trigger of the row
 */
const Action: FC<BoxProps> = ({ children, ...props }) => (
  <Box
    color="grey.0"
    sx={{
      '[role=group]:hover:not(:disabled) &': {
        transform: 'translateX(4px)',
      },
    }}
    transitionDuration="duration-300"
    transitionProperty="transform"
    transitionTimingFunction="ease-out"
    {...props}
  >
    {children}
  </Box>
);

export default Action;
